module.exports = __webpack_public_path__ + "img/editApplication_b.fa47dc1f.png";